import { useRefreshToken } from "stores/hooks/token";
import { isExpired } from "lib/jwt";
import { FunctionComponent, useEffect } from "react";
import { Navigate, Outlet } from "react-router";
import { logout } from "stores/actions/auth";
import { useStore } from "stores/store";
import { router } from "routes/router";

const UserGuard: FunctionComponent<any> = () => {
  const authenticated = useStore((state) => state.authenticated);
  const user = useStore((state) => state.authListUser);
  const refreshToken = useRefreshToken();

  useEffect(() => {
    const tokenInterval = setInterval(() => {
      if (refreshToken && isExpired(refreshToken)) {
        router.navigate("/user/logout");
      }
    }, 15000);
    return () => clearInterval(tokenInterval);
  }, []);

  // check for jwt expire
  if (!authenticated || !user || (refreshToken && isExpired(refreshToken))) {
    logout();
    return <Navigate to="/user/logout" />;
  }

  return <Outlet />;
};

export default UserGuard;
